import type { AudienceId } from '@shared/constants/audiences';
import { User, Building2, Wrench } from 'lucide-react';

export type ProfileId = 'professionnel' | 'entreprise' | 'artisan';

/** Mapping audience stockée → profil DiagnosticFunnel */
export const AUDIENCE_TO_PROFILE: Partial<Record<AudienceId, ProfileId>> = {
  professionnels: 'professionnel',
  entreprises: 'entreprise',
  tertiaire: 'entreprise',
  industrie: 'entreprise',
  collectivites: 'entreprise',
  coproprietes: 'professionnel',
  artisans: 'artisan',
  agriculteurs: 'professionnel',
};

export const PROFILES = [
  {
    id: 'professionnel' as ProfileId,
    label: 'Professionnel indépendant',
    sublabel: 'Artisan, commerçant, profession libérale',
    icon: User,
    iconBg: 'bg-brand-100 text-brand-700',
    ring: 'ring-brand-300',
    selectedBg: 'border-brand-400 bg-brand-50/60',
  },
  {
    id: 'entreprise' as ProfileId,
    label: 'Entreprise',
    sublabel: 'PME, ETI, industrie, tertiaire',
    icon: Building2,
    iconBg: 'bg-lavender-100 text-lavender-700',
    ring: 'ring-lavender-300',
    selectedBg: 'border-lavender-400 bg-lavender-50/60',
  },
  {
    id: 'artisan' as ProfileId,
    label: 'Artisan RGE partenaire',
    sublabel: 'Rejoignez notre réseau mandataire CEE',
    icon: Wrench,
    iconBg: 'bg-accent-100 text-accent-700',
    ring: 'ring-accent-300',
    selectedBg: 'border-accent-400 bg-accent-50/60',
  },
] as const;

export const STEP_LABELS = ['Profil', 'Entreprise', 'Situation', 'Estimation', 'Confirmation'];
export const STEPPER_STEPS = STEP_LABELS.map((label, i) => ({ id: String(i), label }));

export function formatSiret(digits: string): string {
  const parts = [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9), digits.slice(9, 14)];
  return parts.filter(Boolean).join(' ');
}

// Le composant Eyebrow est déplacé dans `./Eyebrow.tsx` (pas de JSX dans un .ts).
// Re-export pour ne pas casser les imports existants `import { Eyebrow } from './types'`.
export { Eyebrow } from './Eyebrow';
